import { PurchaseOrderConfirmComponent } from './purchase-order-confirm/purchase-order-confirm.component';
import { PaymentReceiptComponent } from './payment-receipt/payment-receipt.component';
import { DeliveryOrderReportComponent } from './delivery-order/delivery-order.component';
import { BillOfLadingReportComponent } from './bill-of-lading/bill-of-lading.component';
import { PurchaseProposalComponent } from './purchase-proposal/purchase-proposal.component';

export const ReportRegistry = {
  'PurchaseOrderConfirm': PurchaseOrderConfirmComponent,
  'PaymentReceipt': PaymentReceiptComponent,
  'DeliveryOrder': DeliveryOrderReportComponent,
  'BillOfLading': BillOfLadingReportComponent,
  'PurchaseProposal': PurchaseProposalComponent
};

export type ReportRegistryKeys = keyof typeof ReportRegistry;
export type ReportRegistryComponentType = typeof ReportRegistry[ReportRegistryKeys];
